import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ChevronUp from 'mdi-react/ChevronUpIcon';
import ChevronDown from 'mdi-react/ChevronDownIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import ProductImage from '@prisjakt/ui-product-image';
import T from '@prisjakt/ui-translate';
import CompareIcon from 'mdi-react/ScaleBalanceIcon';

import { trackComparisonLinkClick } from '../../../product-compare/tracking';

import * as S from './styles';

class CompareProductBasket extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    const { products, compareUrl, onEmpty, onProductDelete } = this.props;
    const { expanded } = this.state;

    return (
      <S.Container>
        <S.Header onClick={this.toggle}>
          <S.FlexWrapper>
            <S.ExpandIcon>
              {expanded ? <ChevronDown /> : <ChevronUp />}
            </S.ExpandIcon>
            {products.length === 0 ? (
              <S.InfoText>
                <T domain="product">product-compare.choose-products</T>
              </S.InfoText>
            ) : (
              <S.ProductCount>
                <T domain="lists" n={products.length}>
                  list.n-products
                </T>
              </S.ProductCount>
            )}
          </S.FlexWrapper>
          <S.CompareButton
            size="small"
            color="primary"
            variant="outlined"
            iconPosition="left"
            disabled={products.length < 2}
            onClick={e => {
              e.stopPropagation();
              trackComparisonLinkClick(products.length);
            }}
            component={
              compareUrl ? <Link to={compareUrl} /> : <button type="button" />
            }
          >
            <CompareIcon size={18} />
            <T domain="product">product-compare.compare</T>
          </S.CompareButton>
        </S.Header>
        <S.ProductWrapper count={products.length} expanded={expanded}>
          <S.InfoBar>
            {products.length < 2 && (
              <S.InfoText>
                <T domain="product">product-compare.choose-more-products</T>
              </S.InfoText>
            )}
            <S.ClearButton variant="text" color="link" onClick={onEmpty}>
              <T domain="product">product-compare.cancel-compare</T>
            </S.ClearButton>
          </S.InfoBar>
          {products.map(product => (
            <S.ProductRow
              key={product.id}
              link={product.pathName}
              onClick={e => e.preventDefault()}
              name={product.name}
              image={
                <ProductImage name={product.name} src={product.media.first} />
              }
              price={
                product.priceSummary.regular || product.priceSummary.alternative
              }
              showDivider
            >
              <S.ProductDeleteButton
                size="small"
                variant="icon"
                color="primary"
                icon={<CloseIcon />}
                onClick={onProductDelete(product.id, 'basket')}
              />
            </S.ProductRow>
          ))}
        </S.ProductWrapper>
      </S.Container>
    );
  }
}

CompareProductBasket.propTypes = {
  products: PropTypes.array,
  compareUrl: PropTypes.string,
  onEmpty: PropTypes.func,
  onProductDelete: PropTypes.func,
};

CompareProductBasket.defaultProps = {
  products: [],
  compareUrl: undefined,
  onEmpty: () => {},
  onProductDelete: () => {},
};

export default CompareProductBasket;
